// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo___s8NYS","white":"white___2tLLd"};